<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="1100px">
        <el-form size="small" :model="form" :label-width="formLabelWidth" ref="form">

            <div class="common-form">基本信息</div>
            <el-descriptions class="margin-top" title="" :column="3" size="medium" border>
                <el-descriptions-item>
                    <template slot="label">试卷</template>
                    {{ detail.exam ? detail.exam.title : '' }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">课程</template>
                    {{ detail.course ? detail.course.title : ''}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">用户</template>
                    {{ detail.user ? detail.user.nickName : ''}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">试卷总分</template>
                    {{ detail.total_score ? detail.total_score : 0 }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">考试得分</template>
                    {{ detail.get_score }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">答对题目数</template>
                    {{ detail.right_count }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">答错题目数</template>
                    {{ detail.error_count }}
                </el-descriptions-item>
            </el-descriptions>

            <div class="common-form">答题详情</div>
            <el-table
                    :data="detail.paper.paper"
                    :row-class-name="tableAddClass"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="question_type_desc"
                        label="题目类型"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="title"
                        label="题目名称">
                </el-table-column>
                <el-table-column prop="title" label="是否答对" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.is_right ? '是' : '否' }}
                    </template>
                </el-table-column>
            </el-table>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {examLogDetail} from '@/api/education';

    export default {
        components: { },
        data() {
            return {
                title: '详情',
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,

                form: {},
                exam_answer_id: '',
                detail: {
                    paper:[]
                }
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.$message({message: '获取详情失败', type: 'error'});
                } else {
                    this.exam_answer_id = row.exam_answer_id
                    this.getDetail()
                }
                this.dialogFormVisible = true
            },
            save(){
                this.close()
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.dialogFormVisible = false
            },
            getDetail(){
                examLogDetail({id: this.exam_answer_id}).then((result)=>{
                    this.detail = Object.assign({}, result.data)
                })
            },

            tableAddClass({row,rowIndex}) {
                if (!row.is_right) {
                    return 'tr-red';
                }
                return '';
            }
        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
    /deep/.el-table .tr-red {
        color: red !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/exam/answer/detail.vue